import { AsyncPipe, NgIf, NgClass } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CmsPicturePipe } from '@domgen/dgx-fe-cms';
import { ButtonGroupComponent } from '@domgen/dgx-fe-components/button';
import { QuickLinksComponent } from '@domgen/dgx-fe-components/content';
import { TestHookDirective } from '@domgen/dgx-fe-components/general';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { PictureComponent } from '@domgen/dgx-fe-components/media';
import { SearchInputComponent } from '@domgen/dgx-fe-forms/input';
import {
  FormFieldComponent,
  FormFieldDirective,
  FormRowComponent,
  FormSubmitButtonComponent,
} from '@domgen/dgx-fe-forms/layout';
import { FormSubmitDirective } from '@domgen/dgx-fe-forms/shared';
import { GAContainerDirective, GAFormSubmitDirective } from '@domgen/dgx-fe-ga';
import { EditableArea } from '@magnolia/angular-editor';
import { ArticleSearchFormValue } from '@self-fix/util-models';
import { ArticleSearchFormComponentService } from '../../services/article-search-form-component/article-search-form-component.service';
import { ArticleSearchFormFieldComponent } from '../article-search-form-field/article-search-form-field.component';
import { ENVIRONMENT } from '@domgen/dgx-fe-config';
import { AppEnvironment } from 'apps/dg-self-fix/src/app/models/environment/app-environment.type';

@Component({
  selector: 'article-search-form',
  standalone: true,
  providers: [ArticleSearchFormComponentService],
  imports: [
    ArticleSearchFormFieldComponent,
    AsyncPipe,
    ButtonGroupComponent,
    CmsPicturePipe,
    EditableArea,
    FormFieldComponent,
    FormFieldDirective,
    FormRowComponent,
    FormSubmitButtonComponent,
    FormSubmitDirective,
    GAContainerDirective,
    GAFormSubmitDirective,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgIf,
    PictureComponent,
    QuickLinksComponent,
    ReactiveFormsModule,
    SearchInputComponent,
    TestHookDirective,
    NgClass,
  ],
  templateUrl: './article-search-form.component.html',
  styleUrls: ['./article-search-form.component.scss'],
})
export class ArticleSearchFormComponent implements OnInit {
  @Input() showForm = true;
  scottishPowerDisclaimer!: string;
  constructor(
    readonly cs: ArticleSearchFormComponentService,
    @Inject(ENVIRONMENT) public readonly environment: AppEnvironment
  ) {}

  ngOnInit(): void {
    this.cs.buildForm();
    this.cs.setArticleNotFoundErrors();
    this.scottishPowerDisclaimer = this.scottishPowerDisclaimerText();
  }

  onFormSubmit(formValue: ArticleSearchFormValue): void {
    this.cs.submit(formValue.search);
  }

  isScottishPower(): boolean {
    return this.environment.brandKey === 'scottish';
  }

  isScottishPowerHeating(): boolean {
    return this.environment.name === 'scottish-power-heating';
  }

  scottishPowerDisclaimerText(): string {
    return this.isScottishPowerHeating()
      ? '*All boiler care content is the responsibility of, and updated by, Domestic & General Services Limited.'
      : '*All appliance care content is the responsibility of, and updated by, Domestic & General Services Limited.';
  }
}
